module.exports = __webpack_public_path__ + "img/icon_03.a26d237a.svg";